export const environment = {
  production: false,
  baseUrl: '/main/dispatcher',
  localStorageID: 'dispatcher',
  noAuth: false,

  clientId: '71lv3f0f6geda8i46gpbip9jq3',
  logoutUrl: 'https://emed-dispatcher-dev.sbx-tech.net/main/dispatcher/logout',
  authority: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_cohStOxK8/.well-known/openid-configuration'
};
